import React from "react";
import { ImageDataLike } from "gatsby-plugin-image";
import { IContentfulImage } from "../../types/IContentfulImage";
import "./styles.scss";
import { GatsbyImageOrSvg } from "../../utils/GatsbyImageOrSvg/GatsbyImageOrSvg";

export interface IAsSeenOnPanelProps {
  title: string;
  logos: IContentfulImage[] & ImageDataLike[];
  logosMobile: IContentfulImage[];
  headerAnchor?: string;
}

export const AsSeenOnPanel: React.FC<IAsSeenOnPanelProps> = ({
  title,
  logos,
  logosMobile,
  headerAnchor,
}) => (
  <section id={headerAnchor} className="asSeenOn">
    <header className="asSeenOn__header">{title}</header>
    <div
      className="asSeenOn__logos__container"
      role="region"
      aria-label="As seen on - media"
    >
      {logos
          && (
            <div className="asSeenOn__logos" id="desktop">
              {logos && logos.map((logo, key) => {
                const logoImage = logo as IContentfulImage & ImageDataLike;
                return (
                  <GatsbyImageOrSvg
                    key={key}
                    image={logoImage}
                    loading="lazy"
                    alt={logo.title}
                    className="asSeenOn__imgDesktop"
                  />
                );
              })}
            </div>
          )}
      {logosMobile
          && (
            <div className="asSeenOn__logos" id="mobile">
              {logosMobile.map((logo, key) => {
                const logoImage = logo as IContentfulImage & ImageDataLike;
                return (
                  <div key={key} className="asSeenOn__logo">
                    <GatsbyImageOrSvg
                      image={logoImage}
                      loading="lazy"
                      alt={logo.title}
                      className="asSeenOn__imgMobile"
                    />
                  </div>
                );
              })}
            </div>
          )}
    </div>
  </section>
);
